// ================================================================
// DASHBOARD OPERACIONAL V4 - Command Center Focus
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

window.FazendaRP.Pages.operacional.dashboard = {
    container: null,
    charts: {},

    render: async function (container) {
        this.container = container;

        // Match Global Dashboard CSS if not already present
        this.injectStyles();

        const html = `
            <div style="display:flex; flex-direction:column; height:100%; background: #f3f4f6;">
                
                <!-- Sub-Header -->
                <div style="padding: 15px 25px; background: white; border-bottom: 1px solid #e2e8f0; display:flex; justify-content:space-between; align-items:center;">
                    <div>
                        <h2 style="margin:0; font-size:1.4rem; color:#0f172a; font-weight:700;">Performance Operacional</h2>
                        <p style="margin:0; color:#64748b; font-size:0.9rem;">Diário de Campo • Máquinas • Insumos</p>
                    </div>
                    <div style="display:flex; gap:12px;">
                        <button id="btn-notifications" class="btn btn-surface" style="position:relative;">
                             <i class="fas fa-bell"></i> Notificações
                             <span id="notification-badge"></span>
                        </button>
                        <button class="btn btn-primary" onclick="window.FazendaRP.Pages.operacional.exports.exportDashboardPDF()">
                            <i class="fas fa-file-pdf"></i> Relatório PDF
                        </button>
                    </div>
                </div>

                <div style="padding: 25px; overflow-y: auto; flex:1;">
                    
                    <!-- KPI Cards (V4 Style) -->
                    <div style="display:grid; grid-template-columns:repeat(4, 1fr); gap:20px; margin-bottom:25px;">
                        <div class="dash-card-v4" style="border-left: 4px solid #059669;">
                            <div class="kpi-label">Área Total Cultivada</div>
                            <div class="kpi-val" id="metric-area">--</div>
                            <div class="kpi-sub">hectares totais</div>
                        </div>
                        <div class="dash-card-v4" style="border-left: 4px solid #3b82f6;">
                            <div class="kpi-label">Atividades (30 dias)</div>
                            <div class="kpi-val" id="metric-atividades">--</div>
                            <div class="kpi-sub">nos talhões</div>
                        </div>
                        <div class="dash-card-v4" style="border-left: 4px solid #f59e0b;">
                            <div class="kpi-label">Consumo Diesel (30d)</div>
                            <div class="kpi-val" id="metric-diesel">--</div>
                            <div class="kpi-sub" id="metric-diesel-avg">-- L/ha média</div>
                        </div>
                        <div class="dash-card-v4" style="border-left: 4px solid #8b5cf6;">
                            <div class="kpi-label">Custo Estimado (30d)</div>
                            <div class="kpi-val" id="metric-custo">--</div>
                            <div class="kpi-sub">mão de obra + insumos</div>
                        </div>
                    </div>

                    <!-- Main Charts Row -->
                    <div style="display:grid; grid-template-columns: 2fr 1fr; gap:20px; margin-bottom:20px;">
                        <!-- Timeline -->
                        <div class="dash-card-v4">
                            <div class="dash-title" style="margin-bottom:20px;"><i class="fas fa-chart-line"></i> Intensidade de Operações</div>
                            <div style="height:300px;"><canvas id="chart-timeline"></canvas></div>
                        </div>
                        <!-- Status Pie -->
                        <div class="dash-card-v4">
                            <div class="dash-title" style="margin-bottom:20px;"><i class="fas fa-tasks"></i> Prescrições</div>
                            <div style="height:300px;"><canvas id="chart-status-prescricoes"></canvas></div>
                        </div>
                    </div>

                    <!-- Bottom Grid -->
                    <div style="display:grid; grid-template-columns: 1fr 1fr 1fr; gap:20px;">
                        <div class="dash-card-v4">
                            <div class="dash-title"><i class="fas fa-gas-pump"></i> Consumo Diesel por Dia (L)</div>
                            <div style="height:250px;"><canvas id="chart-diesel-diario"></canvas></div>
                        </div>
                        <div class="dash-card-v4">
                            <div class="dash-title"><i class="fas fa-dollar-sign"></i> Custos por Operação</div>
                            <div style="height:250px;"><canvas id="chart-custos-operacao"></canvas></div>
                        </div>
                        <div class="dash-card-v4">
                            <div class="dash-title"><i class="fas fa-seedling"></i> Área por Variedade</div>
                            <div style="height:250px;"><canvas id="chart-area-variedade"></canvas></div>
                        </div>
                    </div>

                    <!-- Varieties List -->
                    <div class="dash-card-v4" style="margin-top:25px;">
                        <div class="dash-title"><i class="fas fa-list"></i> Detalhamento por Variedade</div>
                        <div id="variedades-list" style="display:flex; flex-wrap:wrap; gap:10px; margin-top:15px;"></div>
                    </div>

                </div>
            </div>
        `;

        container.innerHTML = html;
        await this.loadData();
        await this.setupNotifications();
    },

    injectStyles: function () {
        if (document.getElementById('dash-ops-v4-style')) return;
        const style = document.createElement('style');
        style.id = 'dash-ops-v4-style';
        style.innerHTML = `
            .dash-card-v4 { background: white; border-radius: 12px; padding: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb; }
            .kpi-label { font-size: 0.75rem; color: #64748b; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px; }
            .kpi-val { font-size: 1.8rem; font-weight: 700; color: #0f172a; margin-top: 4px; font-family: 'Outfit'; }
            .kpi-sub { font-size: 0.75rem; color: #94a3b8; margin-top: 2px; }
            .dash-title { font-weight: 600; color: #1e293b; display: flex; align-items: center; gap: 8px; }
            .btn { border: none; padding: 10px 20px; border-radius: 8px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 8px; }
            .btn-primary { background: #059669; color: white; }
            .btn-surface { background: white; border: 1px solid #e2e8f0; color: #1e293b; }
            #notification-badge:not(:empty) { position: absolute; top: -5px; right: -5px; background: #ef4444; color: white; font-size: 0.7rem; padding: 2px 6px; border-radius: 10px; }
        `;
        document.head.appendChild(style);
    },

    loadData: async function () {
        const shared = window.FazendaRP.Pages.operacional.shared;
        await shared.loadVariedades();

        try {
            // Metrics
            const areaTotal = shared.variedadesCache.reduce((sum, v) => sum + (parseFloat(v.area_hectares) || 0), 0);
            document.getElementById('metric-area').textContent = areaTotal.toFixed(1);

            // Fetch Prescriptions (Active/Approved)
            const { data: prescricoes } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .in('status', ['Pendente', 'Aprovada']);

            // Fetch Activities (Last 30 Days)
            const d30 = new Date();
            d30.setDate(d30.getDate() - 30);
            const d30Str = d30.toISOString().split('T')[0];

            const { data: atividades } = await window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*')
                .gte('data_atividade', d30Str);

            const activitiesList = atividades || [];

            // Update Counts
            document.getElementById('metric-atividades').textContent = activitiesList.length;

            const totalCost = activitiesList.reduce((sum, a) => sum + (parseFloat(a.custo_total) || 0), 0);
            document.getElementById('metric-custo').textContent = shared.formatCurrency(totalCost);

            // Diesel Logic
            let totalDiesel = 0;
            let dieselDays = {};

            activitiesList.forEach(a => {
                const insumos = Array.isArray(a.insumos) ? a.insumos : [];
                insumos.forEach(i => {
                    const nome = (i.nome || '').toLowerCase();
                    if (nome.includes('diesel')) {
                        const qtd = parseFloat(i.qtd_total) || 0;
                        totalDiesel += qtd;
                        const dt = a.data_atividade;
                        dieselDays[dt] = (dieselDays[dt] || 0) + qtd;
                    }
                });
            });

            document.getElementById('metric-diesel').textContent = totalDiesel.toFixed(0) + " L";
            const avgDiesel = activitiesList.length > 0 ? (totalDiesel / areaTotal).toFixed(2) : "0.00";
            document.getElementById('metric-diesel-avg').textContent = `Média: ${avgDiesel} L/ha`;

            // Render Charts
            this.renderCharts(activitiesList, prescricoes || [], dieselDays);
            this.renderVariedadesList();

        } catch (err) {
            console.error('Ops Dash Load Error:', err);
        }
    },

    renderCharts: function (atividades, prescricoes, dieselDays) {
        // --- 1. Timeline ---
        const timelineCtx = document.getElementById('chart-timeline');
        const tasksByDay = {};
        atividades.forEach(a => { tasksByDay[a.data_atividade] = (tasksByDay[a.data_atividade] || 0) + 1; });
        const labels = Object.keys(tasksByDay).sort();
        const dataTasks = labels.map(l => tasksByDay[l]);

        this.updateChart('timeline', timelineCtx, {
            type: 'line',
            data: {
                labels: labels.map(l => l.split('-').reverse().slice(0, 2).join('/')),
                datasets: [{
                    label: 'Nº de Atividades',
                    data: dataTasks,
                    borderColor: '#3b82f6',
                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                    fill: true, tension: 0.4, pointRadius: 4
                }]
            }
        });

        // --- 2. Prescriptions Pie ---
        const pieCtx = document.getElementById('chart-status-prescricoes');
        const stats = { 'Pendente': 0, 'Aprovada': 0, 'Executada': 0 };
        prescricoes.forEach(p => { if (stats[p.status] !== undefined) stats[p.status]++; });

        this.updateChart('status', pieCtx, {
            type: 'doughnut',
            data: {
                labels: Object.keys(stats),
                datasets: [{
                    data: Object.values(stats),
                    backgroundColor: ['#f59e0b', '#3b82f6', '#059669'],
                    borderWidth: 2
                }]
            },
            options: { plugins: { legend: { position: 'bottom' } } }
        });

        // --- 3. Diesel Daily ---
        const dieselCtx = document.getElementById('chart-diesel-diario');
        const dieselLabels = Object.keys(dieselDays).sort();
        const dieselData = dieselLabels.map(l => dieselDays[l]);

        this.updateChart('diesel', dieselCtx, {
            type: 'bar',
            data: {
                labels: dieselLabels.map(l => l.split('-').reverse().slice(0, 2).join('/')),
                datasets: [{
                    label: 'Litros',
                    data: dieselData,
                    backgroundColor: '#6366f1',
                    borderRadius: 4
                }]
            }
        });

        // --- 4. Custos por Operação ---
        const costosCtx = document.getElementById('chart-custos-operacao');
        const costsByType = {};
        atividades.forEach(a => {
            const t = a.tipo_operacao || 'Outros';
            costsByType[t] = (costsByType[t] || 0) + (parseFloat(a.custo_total) || 0);
        });

        this.updateChart('costs', costosCtx, {
            type: 'bar',
            data: {
                labels: Object.keys(costsByType),
                datasets: [{
                    label: 'R$',
                    data: Object.values(costsByType),
                    backgroundColor: '#10b981',
                    borderRadius: 4
                }]
            },
            options: { indexAxis: 'y' }
        });

        // --- 5. Área por Variedade ---
        const areaCtx = document.getElementById('chart-area-variedade');
        const areaByVar = {};
        const varCache = window.FazendaRP.Pages.operacional.shared.variedadesCache;
        atividades.forEach(a => {
            if (Array.isArray(a.variedades_ids)) {
                const areaPerVar = (parseFloat(a.area_total_aplicada) || 0) / a.variedades_ids.length;
                a.variedades_ids.forEach(id => {
                    const name = varCache.find(v => v.id === id)?.nome || 'Outra';
                    areaByVar[name] = (areaByVar[name] || 0) + areaPerVar;
                });
            }
        });

        this.updateChart('area', areaCtx, {
            type: 'pie',
            data: {
                labels: Object.keys(areaByVar),
                datasets: [{
                    data: Object.values(areaByVar),
                    backgroundColor: ['#059669', '#3b82f6', '#f59e0b', '#8b5cf6', '#ec4899'],
                    borderWidth: 1
                }]
            },
            options: { plugins: { legend: { position: 'bottom' } } }
        });
    },

    updateChart: function (id, ctx, config) {
        if (!ctx) return;
        if (this.charts[id]) this.charts[id].destroy();

        // Merge shared defaults
        const defaults = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: id === 'status' || id === 'area' } },
            scales: (id === 'status' || id === 'area') ? {} : {
                y: { beginAtZero: true, grid: { color: '#f1f5f9' } },
                x: { grid: { display: false } }
            }
        };

        const finalConfig = {
            ...config,
            options: { ...defaults, ...(config.options || {}) }
        };

        this.charts[id] = new Chart(ctx, finalConfig);
    },

    renderVariedadesList: function () {
        const shared = window.FazendaRP.Pages.operacional.shared;
        const container = document.getElementById('variedades-list');
        if (!container) return;

        if (shared.variedadesCache.length === 0) {
            container.innerHTML = '<p style="color:#94a3b8; font-size:0.9rem;">Nenhuma variedade cadastrada.</p>';
            return;
        }

        container.innerHTML = shared.variedadesCache.map(v => `
            <div style="background:white; border:1px solid #e5e7eb; border-radius:10px; padding:12px 18px; min-width:140px;">
                <div style="font-weight:700; color:#1e293b; font-size:0.95rem;">${v.nome}</div>
                <div style="font-size:0.8rem; color:#64748b;">${v.area_hectares} ha • ${v.cultura_atual}</div>
            </div>
        `).join('');
    },

    setupNotifications: async function () {
        const notif = window.FazendaRP.Pages.operacional.notifications;
        const badge = document.getElementById('notification-badge');
        if (!badge) return;

        await notif.fetch();
        badge.innerText = notif.unreadCount > 0 ? notif.unreadCount : '';

        document.getElementById('btn-notifications').onclick = async () => {
            await notif.openModal();
            setTimeout(async () => {
                await notif.fetch();
                badge.innerText = notif.unreadCount > 0 ? notif.unreadCount : '';
            }, 1000);
        };
    }
};
